import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

const LOCK_KEY = 'auth_redirect_in_progress';
const TAB_REDIRECT_KEY = 'auth_redirect_started_in_this_tab';

export function AuthRedirectLockCleaner() {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status !== 'authenticated') return;
    if ((session as any)?.error) return;

    localStorage.removeItem(LOCK_KEY);
    sessionStorage.removeItem(TAB_REDIRECT_KEY);
  }, [session, status]);

  return null;
}
